export const Testing = {
    "答题提示":"答題提示",
    "点击查看答题提示":"點擊查看答題提示",
    "知识卡":"知識卡",
    "资料":"資料",
    "共":"共",
    "题":"題",
    "被打回":"被打回",
    "用时":"用时",
    "不限时":"不限時",
    "时":"時",
    "分":"分",
    "请选择":"請選擇",
    "匿名":"匿名",
    "实名":"實名",
    "得分":"得分:",
    "回答正确":"回答正確",
    "回答错误":"回答錯誤",
    "不能大于此题分数":"不能大於此題分數",
    "学生答案":"學生答案：",
    "回答错误得分0":"回答錯誤, 得分: 0",
    "作答者正确率":"作答者正確率: ",
    "份待批改":"份待批改",
    "还有":"還有",
    "道题未作答":"道題未作答",
    "您只有一次机会提交后不可更改":"您只有壹次機會，提交後不可更改",
    "提交成功":"提交成功",
    "您的试卷已经成功提交":"您的試卷已經成功提交",
    "是否直接前往发布测试":"是否直接前往發布測試？",
    "前往发布设置":"前往發布設置",
    "稍后再说":"稍後再說",
    "普通测试":"普通測試",
    "考试":"考試",
    "测试类型":"測試類型",
    "预览试题":"預覽試題",
    "测试标题":"測試標題",
    "测试设置":"測試設置",
    "是否同步发送给学生":"是否同步發送給學生",
    "测试详情":"測試詳情",
    "开启后在完成添加的同时会将本活动发布给学生":"開啟後，在完成添加的同時會將本活動發布給學生",
    "限时答题":"限時答題",
    "不随机":"不隨機",
    "按题型抽取":"按題型抽取",
    "按题目区块抽取":"按題目區塊抽取",
    "添加测试":"添加測試",
    "是否发布测试":"是否發布測試?",
    "发布中":"發布中...",
    "确认发布":"確認發布",
    "天":"天",
    "0分钟":"0分鐘",
    "选":"選",
    "的人":"的人",
    "正确学生":"正確學生",
    "错误学生":"錯誤學生",
    "查看学生答案":"查看學生答案",
    "确定打回该学生的试卷吗":"確定打回該學生的試卷嗎?",
    "打回成功":'打回成功',
    "已经是最后一个学生":"已經是最後壹個學生",
    "已经是第一个学生":"已經是第壹個學生",
    "您的试卷未提交可以继续作答哦":"您的試卷未提交，可以繼續作答哦！",
    "您的测试已被老师打回了需要重新提交才算成绩哦":"您的測試已被老師打回了，需要重新提交才算成績哦！",
    "点击下方查看试卷可以查看作答情况":"點擊下方“查看試卷”可以查看作答情況",
    "等待老师批改点击下方查看试卷可以查看作答情况":"等待老師批改，點擊下方“查看試卷”可以查看作答情況",
    "成绩未公布请您耐心等待":"成績未公布，請您耐心等待！",
    "测试已结束点击下方查看试卷可以查看试卷":"測試已結束，點擊下方“查看試卷”可以查看試卷",
    "本试卷共":"本試卷共",
    "本场考试已开启防切屏模式切换页面":"本場考試已開啟防切屏模式, 切換頁面",
    "次后将强制交卷请谨慎答题勿退出答题页面":"次後將強制交卷, 請謹慎答題勿退出答題頁面!",
    "线下测试":"線下測試",
    "查看试卷":"查看試卷",
    "重新答题":"重新答題",
    "继续答题":"繼續答題",
    "成绩不公布":"成績不公布",
    "测试已结束未参与":"測試已結束, 未參與!",
    "我的作答":"我的作答",
    "测试已结束系统已自动收取试卷":"測試已結束，系統已自動收取試卷",
    "您已跳出答题页面":"您已跳出答題頁面",
    "次系统将在":"次, 系統將在",
    "后自动交卷":"後自動交卷!",
    "次再跳出":"次, 再跳出",
    "次将":"次將",
    "自动交卷":"自動交卷",
    "请谨慎答题":",請謹慎答題!",
    "15秒后系统将自动交卷":"15秒後, 系統將自動交卷!",
    "答题过程中不允许回退":"答題過程中不允許回退",
    "闯关答题不允许回退":"闖關答題不允許回退",
    "您的网络出现问题答案保存失败请检查当前网络是否有问题恢复网络后请重新答题":"您的網絡出現問題，答案保存失敗！請檢查當前網絡是否有問題，恢復網絡後請重新答題",
    "确定提交当前试卷":'確定提交當前試卷？',
    "您是否进行返回当前返回将被记录为切屏":"您是否進行返回？當前返回將被記錄為切屏",
    "1次":"1次",
    "放弃返回":"放棄返回",
    "继续返回":"繼續返回",
    "客观题":"客觀題",
    "正确":"正確",
    "错误":"錯誤",
    "主观题":"主觀題",
    "全部解析":"全部解析",
    "错题解析":"錯題解析",
    "试卷还未批改暂无数据分析":"試卷還未批改，暫無數據分析",
    "请确认是否要":"請確認是否要",
    "打回后学生需要重新提交":"打回後, 學生需要重新提交",
    "催交的学生将会受到催交信息":"催交的學生將會受到催交信息",
    "确认催交":"確認催交",
    "待批":"待批",
    "批阅状态":'批閱狀態',
    "删除测试":'刪除測試',
    "确定要删除测试吗":"確定要刪除測試嗎?",
    "抽题测试":"抽題測試",
    "题目顺序随机打乱":"題目順序隨機打亂",
    "选项顺序随机打乱":"選項順序隨機打亂",
    "答案公布设置":"答案公布設置",
    "成绩公布设置":"成績公布設置",
    "交卷后允许查看试卷":'交卷後允許查看試卷',
    "多选题计分方式":"多選題計分方式",
    "填空题计分方式":"填空題計分方式",
    "填空题大小写敏感":"填空題大小寫敏感",
    "允许复制试题":"允許復制試題",
    "允许粘贴答案":"允許粘貼答案", 
    "答案展示样式":"答案展示樣式",
    "答题过程可以回退":"答題過程可以回退",
    "目前该测试考试正在进行中无法进行切屏设置":"目前該測試(考試)正在進行中,無法進行切屏設置",
    "切屏后强制交卷":"切屏後強制交卷",
    "切屏次数":"切屏次數",
    "学生切屏页面超过后将强制交卷":"學生切屏頁面超過後將強制交卷",
    "请输入次数":"請輸入次數",
    "当学生在当前设备上每离开一次答题界面将给予提示如果切换页面超出上限后将被强制交卷":"當學生在當前設備上，每離開壹次答題界面，將給予提示，如果切換頁面超出上限後將被強制交卷。",
    "注设置次数时请考虑设备及网络等异常情况例如手机端会存在电话呼入电脑端广告弹框不小心无操作切出等":"註：設置次數時請考慮設備及網絡等異常情況，例如：手機端會存在電話呼入，電腦端廣告彈框，不小心無操作切出等；",
    "特别注意电脑端作答文件题时上传图片算作1次切屏手机端由于不同的操作系统会导致切换到手机桌面其他应用或者文件题上传图片时会每5秒记一次切屏":"電腦端作答文件題時，上傳圖片算作1次切屏；手機端由於不同的操作系統，會導致切換到手機桌面、其他應用或者文件題上傳圖片時會每5秒記壹次切屏！",
    "允许多设备作答":"允許多設備作答",
    "不随机打乱":"不隨機打亂",
    "全题目顺序随机打乱":"全題目順序隨機打亂",
    "同一题型内题目顺序随机打乱":"同壹題型內題目順序隨機打亂",
    "不公布":"不公布",
    "学生交卷后公布答案":"學生交卷後公布答案",
    "到截止时间公布答案":"到截止時間公布答案",
    "成绩出来之后立即看到":"成績出來之後立即看到",
    "多选少选错选不得分":"多選、少選、錯選不得分",
    "少选时按照选项个数计分":"少選時，按照選項個數計分",
    "少选时得一半分数":"少選時，得壹半分數",
    "与答案不全匹配时手动批改":"與答案不全匹配時，手動批改",
    "与答案不全匹配时机器自动批改":"與答案不全匹配時，機器自動批改",
    "与答案不全匹配时自动0分":"與答案不全匹配時，自動0分",
    "不敏感":"不敏感",
    "大小写敏感":"大小寫敏感",
    "一页式":"壹頁式",
    "单题卡片式":"單題卡片式",
    "目前该测试考试正在进行中若更改设置可能影响学生的答题数据":"目前該測試(考試)正在進行中,若更改設置可能影響學生的答題數據",
    "确定更改":"確定更改",
    "目前该测试考试已结束若更改设置可能影响学生的答题结果":"目前該測試(考試)已結束,若更改設置可能影響學生的答題結果",
    "当前设置为一页式答题过程可以回退设置无效":"當前設置為壹頁式，答題過程可以回退設置無效!",
    "请输入0100之间的整数":"請輸入0~100之間的整數",
    "随机抽取试题":"隨機抽取試題",
    "题目数量":"題目數量",
    "最多可选":"最多可選",
    "每张试卷":"每張試卷",
    "从第":"從第",
    "题第":"題~第",
    "题抽取":"题 抽取",
    "增加抽取范围":"增加抽取範圍",
    "随机抽取的题目个数不能全部为0":"隨機抽取的題目個數不能全部為0",
    "没有该题":"沒有該題",
    "最多抽取":"最多抽取",
    "测试未开始":"測試未開始",
    "距离开始还剩":"距離開始還剩",
    "测试进行中":"測試進行中",
    "建议不要修改测试参数以免影响学生答题数据":"建議不要修改測試參數，以免影響學生答題數據！",
    "请确认是否结束该测试":"請確認是否結束該測試",
    "批阅测试":"批閱測試",
    "测试分析":"測試分析",
    "手动结束测试":"手動結束測試",
    "闯关测试":"闖關測試",
    "练习":"練習",
    "开始闯关":"開始闖關",
    "闯关完成":"闖關完成",
    "继续闯关":"繼續闖關",
    "薄弱知识点":"薄弱知識點",
    "提升":"提升",
    "未闯关":"未闖關",
    "已完成":"已完成",
    "闯关中":"闖關中",
    "未开始":"未開始",
    "闯关情况":"闖關情況",
    "进行中":"進行中",
    "未参与":"未參與",
    "正在提交中请稍后":"正在提交中，請稍後...",
    "提交失败请重试":"提交失敗，請重試",
    "确定继续闯关吗":"確定繼續闖關嗎？",
    "正在初始化闯关请稍后":"正在初始化闖關，請稍後...",
    "闯关初始化失败请重试":"闖關初始化失敗，請重試",
}